import {
  IconAdjustments,
  IconAlertTriangle,
  IconArrowsDiff,
  IconBell,
  IconCheck,
  IconChecks,
  IconChevronDown,
  IconChevronRight,
  IconCircleCheck,
  IconClock,
  IconCloudUpload,
  IconCopy,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconEye,
  IconFilter,
  IconHistory,
  IconDotsVertical,
  IconListCheck,
  IconPlus,
  IconReceipt,
  IconRefresh,
  IconSearch,
  IconSend,
  IconTrash,
  IconUpload,
  IconUserQuestion,
  IconX,
  IconArrowBackUp,
  IconZoomIn,
  IconZoomOut,
  IconRotateClockwise,
  IconArrowLeft,
  IconArrowRight,
} from '@tabler/icons-react';
import type { IconComponent } from './iconTypes';

/** Canonical action icons — pages must not pick Tabler icons ad hoc for these operations. */
export const actionIcons = {
  search: IconSearch,
  filter: IconFilter,
  add: IconPlus,
  edit: IconEdit,
  save: IconCheck,
  delete: IconTrash,
  cancel: IconX,
  close: IconX,
  retry: IconRefresh,
  refresh: IconRefresh,
  upload: IconUpload,
  download: IconDownload,
  view: IconEye,
  openDetails: IconExternalLink,
  moreActions: IconDotsVertical,
  history: IconHistory,
  copy: IconCopy,
  externalLink: IconExternalLink,
  undo: IconArrowBackUp,
  settings: IconAdjustments,
  notify: IconBell,
  expand: IconChevronDown,
  collapse: IconChevronRight,
  send: IconSend,
  check: IconCircleCheck,
  checks: IconChecks,
  alert: IconAlertTriangle,
  clock: IconClock,
  receipt: IconReceipt,
  listCheck: IconListCheck,
  cloudUpload: IconCloudUpload,
  userQuestion: IconUserQuestion,
  diff: IconArrowsDiff,
  zoomIn: IconZoomIn,
  zoomOut: IconZoomOut,
  rotate: IconRotateClockwise,
  previous: IconArrowLeft,
  next: IconArrowRight,
} as const satisfies Record<string, IconComponent>;

export type ActionIconName = keyof typeof actionIcons;
